import { render, staticRenderFns } from "./DetailInbound.vue?vue&type=template&id=54a2489f&scoped=true&"
import script from "./DetailInbound.vue?vue&type=script&lang=js&"
export * from "./DetailInbound.vue?vue&type=script&lang=js&"
import style0 from "./DetailInbound.vue?vue&type=style&index=0&id=54a2489f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2489f",
  null
  
)

export default component.exports